<swiper
    *ngIf="!isLoading && isVisible"
    class="swiper-container dr-container"
    [config]="config"
    #usefulSwiper
>
    <div class="swiper-wrapper">
        <div
            class="swiper-slide"
            [ngClass]="{
                'active-slide': '' === sectionId
            }"
        >
            <a [routerLink]="['/']" class="dr-slide">
                <div class="dr-text">
                    {{ "Home" | translate }}
                </div>
            </a>
        </div>
        <div
            class="swiper-slide"
            *ngFor="let drawerItem of drawerItems"
            [ngClass]="{
                'active-slide': drawerItem.id.toString() === sectionId
            }"
        >
            <a
                [routerLink]="drawerItem.pathItems"
                class="dr-slide"
                (click)="redirectToCategoryPage(drawerItem, $event)"
            >
                <div class="dr-text">
                    {{ drawerItem.name }}
                </div>
            </a>
        </div>
    </div>
    <div class="fade-overlay"></div>
</swiper>
<div *ngIf="isLoading && isVisible" class="dr-container dr-loading-container">
    <div class="swiper-wrapper">
        <div *ngFor="let skeleton1 of loadingDrawerItemPlaceholders">
            <div class="dr-slide">
                <div mdSkeleton class="dr-loading-text"></div>
            </div>
        </div>
    </div>
</div>
